import React from "react";
import { Button, Stack } from "@altimateai/lego";

interface PaginationProps {
  showing: number;
  total: number | undefined;
  offset: number;
  hasMore: boolean | undefined;
  onPrevPage: () => void;
  onNextPage: () => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  showing,
  total,
  offset,
  hasMore,
  onPrevPage,
  onNextPage,
}) => {
  return (
    <Stack direction="row" justify="between" align="center">
      <div className="al-text-sm al-text-gray-500">
        Showing {showing} runs
        {total && <span> of {total} total</span>}
      </div>
      <Stack direction="row" gap="sm">
        <Button variant="outline" size="sm" onClick={onPrevPage} disabled={offset === 0}>
          Previous
        </Button>
        <Button variant="outline" size="sm" onClick={onNextPage} disabled={!hasMore}>
          Next
        </Button>
      </Stack>
    </Stack>
  );
};
